import moment from 'moment'
import { required, minLength } from 'vuelidate/lib/validators'

const DATE_FORMAT = 'YYYY-MM-DD'

const dateToMoment = (value) => moment(value, DATE_FORMAT)

function minDate(value) {
    if (this.onePage) {
        const periodStart = dateToMoment(this.onePage.period_start)
        return dateToMoment(value).isSameOrAfter(periodStart)
    }

    return true
}

function maxDate(value) {
    if (this.onePage) {
        const periodEnd = dateToMoment(this.onePage.period_end)
        return dateToMoment(value).isSameOrBefore(periodEnd)
    }

    return true
}

function mustBeAfterStartDate(value, context) {
    const startDate = dateToMoment(context.date_start)
    return dateToMoment(value).isAfter(startDate)
}

export default {
    onePageHorizons: {
        minLength: minLength(3),
        $each: {
            index: {},
            description: {
                required,
            },
            date_start: {
                required,
                minDate,
                maxDate,
            },
            date_end: {
                required,
                minDate,
                maxDate,
                mustBeAfterStartDate,
            },
        },
    },
}
